'use client'

import { useGATracking } from '@/hooks/analytics/use-ga-tracking'

export function GATrackingProvider({
  children,
  shouldShowGATracking,
}: {
  children: React.ReactNode
  shouldShowGATracking: boolean
}) {
  useGATracking(shouldShowGATracking)
  return <>{children}</>
}
